import React, { useState } from 'react';
import SpinWheel from '../components/SpinWheel';
import ConsultationPopup from '../components/ConsultationPopup';
import { useConsultation } from '../contexts/ConsultationContext';
import '../styles/pages/promotion.css';
import tukiLogo from '../assets/images/logos.png';

interface Prize {
  id: number;
  text: string;
  color: string;
  textColor?: string;
}

const Promotion: React.FC = () => {
  const [wonPrize, setWonPrize] = useState<Prize | null>(null);
  const { isPopupOpen, openPopup, closePopup, popupSource, prizeWon, handleConsultationSuccess } = useConsultation();

  const handlePrizeWon = (prize: Prize) => {
    setWonPrize(prize);
    // Don't auto open popup - let user click the button if they want to
  };

  const handleClaimPrize = () => {
    // Mở popup và truyền thông tin phần thưởng
    openPopup('promotion', wonPrize?.text);
  };

  return (
    <div className="promotion-page">
      {/* Main Layout - Hero Left, Wheel Right */}
      <div className="promotion-main-layout">
        {/* Left Column - Hero + Prizes */}
        <div className="promotion-left-column">
          {/* Hero Section - Left */}
          <section className="promotion-hero">
            <div className="promotion-hero-background">
              <div className="hero-particles">
                {[...Array(30)].map((_, i) => (
                  <div
                    key={i}
                    className="hero-particle"
                    style={{
                      '--particle-x': `${Math.random() * 100}%`,
                      '--particle-y': `${Math.random() * 100}%`,
                      '--particle-delay': `${Math.random() * 5}s`,
                      '--particle-duration': `${5 + Math.random() * 10}s`
                    } as React.CSSProperties}
                  ></div>
                ))}
              </div>
            </div>

            <div className="promotion-hero-content">
              <div className="promotion-hero-badge">
                <span className="badge-icon">🎁</span>
                <span className="badge-text">Ưu đãi đặc biệt</span>
              </div>

              <h1 className="promotion-hero-title">
                Vòng Quay May Mắn
                <img src={tukiLogo} alt="TUKI GROUP" className="title-logo" />
              </h1>

              <p className="promotion-hero-subtitle">
                Quay ngay để nhận ưu đãi hấp dẫn cho shop của bạn!
                <br />
                Mỗi lượt quay là một cơ hội nhận quà giá trị
              </p>

              <div className="promotion-hero-features">
              <div className="feature-item">
                  <div className="feature-icon">✨</div>
                  <div className="feature-text">Quay miễn phí ngay hôm nay</div>
                </div>
                <div className="feature-item">
                  <div className="feature-icon">🎯</div>
                  <div className="feature-text">Bộ Ebook trị giá 5tr</div>
                </div>
                <div className="feature-item">
                  <div className="feature-icon">🎁</div>
                  <div className="feature-text">Nhận quà độc quyền từ TUKI GROUP</div>
                </div>
              </div>
            </div>
          </section>

          {/* Prizes Section - Below Hero */}
          <section className="promotion-prizes-section-compact">
            <h2 className="section-title">Các Phần Thưởng Hấp Dẫn</h2>
            <div className="prizes-grid-compact">
              <div className="prize-card-compact">
                <div className="prize-card-icon-compact">💰</div>
                <h3 className="prize-card-title-compact">Voucher Giá Trị</h3>
                <p className="prize-card-description-compact">
                  Voucher từ 50k - 500k VNĐ
                </p>
              </div>

              <div className="prize-card-compact">
                <div className="prize-card-icon-compact">🎯</div>
                <h3 className="prize-card-title-compact">Khám Shop Miễn Phí</h3>
                <p className="prize-card-description-compact">
                  Đánh giá toàn diện shop
                </p>
              </div>

              <div className="prize-card-compact">
                <div className="prize-card-icon-compact">💬</div>
                <h3 className="prize-card-title-compact">Tư Vấn 1-1</h3>
                <p className="prize-card-description-compact">
                  Tư vấn trực tiếp miễn phí
                </p>
              </div>

              <div className="prize-card-compact">
                <div className="prize-card-icon-compact">🎁</div>
                <h3 className="prize-card-title-compact">Giảm Giá Dịch Vụ</h3>
                <p className="prize-card-description-compact">
                  Giảm 5% cho tất cả dịch vụ
                </p>
              </div>
            </div>
          </section>
        </div>

        {/* Spin Wheel Section - Right */}
        <section className="promotion-wheel-section">
          <div className="container-custom">
            <div className="promotion-wheel-header">
            </div>

            <SpinWheel onPrizeWon={handlePrizeWon} />

            {wonPrize && (
              <div className="prize-announcement">
                <div className="announcement-glow"></div>
                <h3 className="announcement-title">🎊 Phần thưởng của bạn 🎊</h3>
                <p className="announcement-prize">{wonPrize.text}</p>
                <p className="announcement-note">
                  Liên hệ với chúng tôi để nhận ưu đãi ngay!
                </p>
                <button
                  className="announcement-button"
                  onClick={handleClaimPrize}
                >
                  Nhận ưu đãi ngay
                </button>
              </div>
            )}
          </div>
        </section>
      </div>

      {/* Consultation Popup */}
      <ConsultationPopup
        isOpen={isPopupOpen}
        onClose={closePopup}
        onSuccess={handleConsultationSuccess}
        source={popupSource}
        prizeWon={prizeWon}
      />
    </div>
  );
};

export default Promotion;
